import { render, staticRenderFns } from "./TheMenu.vue?vue&type=template&id=511888b6&scoped=true"
import script from "./TheMenu.vue?vue&type=script&lang=ts"
export * from "./TheMenu.vue?vue&type=script&lang=ts"
import style0 from "./TheMenu.vue?vue&type=style&index=0&id=511888b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511888b6",
  null
  
)

export default component.exports